"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var Blinds = function Blinds(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#000' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size;
  var iconSize = size === 'original' ? 'width="25.54" height="24.66"' : 'width="100%"';
  var title = 'Window Blinds Icon';
  return "\n    <svg role=\"img\" aria-label=\"".concat(title, "\" xmlns=\"http://www.w3.org/2000/svg\" ").concat(iconSize, " viewBox=\"0 0 25.54 24.66\">\n      <title>").concat(title, "</title>\n      <path\n        d=\"M3.31,0,0,4.82H8.17v1H3.31L0,10.63H8.17v1H3.31L0,16.44H8.17V19h-1l-1,5.69h6.2l-1-5.69h-1V16.44H25.54V11.61H10.3v-1H25.54V5.81H10.3v-1H25.54V0Zm.93,1.77H23.76V3.05H3.36ZM10.3,8.22V7.58H23.76V8.86H3.36l.88-1.28H8.17v.64Zm0,5.67v-.5H23.76v1.27H3.36l.88-1.27H8.17v.5ZM8.63,20.74H9.84l.38,2.14h-2Z\"\n        style=\"fill: ").concat(color, "; fill-rule: evenodd;\"\n      />\n    </svg>\n  ");
};

var _default = Blinds;
exports["default"] = _default;